import { useCallback, useMemo, useState } from 'react';

import { Platform } from '../types/index.js';

export const useVirtualPlatformAdding = (filteredIntegrations: Platform[]) => {
  const [integratedVirtualIntegrationId, setIntegratedVirtualIntegrationId] =
    useState<number | null>(null);

  const onIntegrateButtonClick = useCallback((id: number | null) => {
    setIntegratedVirtualIntegrationId(id);
  }, []);

  const finalFilteredIntegrations = useMemo(() => {
    if (!integratedVirtualIntegrationId) {
      return filteredIntegrations;
    }
    return filteredIntegrations.map((integration: Platform) =>
      integratedVirtualIntegrationId === integration.id
        ? { ...integration, isIntegrated: true }
        : integration,
    );
  }, [filteredIntegrations, integratedVirtualIntegrationId]);

  return { finalFilteredIntegrations, onIntegrateButtonClick };
};
